<script setup lang="ts">
import { computed } from 'vue';

import { useAuthStore } from '@/entities/auth';
import { AppButton } from '@/shared/ui';

import { useLocationSelection } from '../model/use-location-selection';

/** «Перейти в X и …»: деньги и касса записи другой локации — только после перехода в неё. */
const props = withDefaults(defineProps<{ locationId: string; label: string; size?: 'sm' | 'md' }>(), {
  size: 'md',
});
const emit = defineEmits<{ switched: [] }>();

const authStore = useAuthStore();
const { isLoading, selectLocation } = useLocationSelection();
const target = computed(() => authStore.availableLocations.find((location) => location.id === props.locationId));

async function switchToTarget(): Promise<void> {
  if (target.value && (await selectLocation(target.value))) {
    emit('switched');
  }
}
</script>

<template>
  <AppButton
    v-if="target"
    :size="size"
    outline
    :loading="isLoading"
    @click="switchToTarget"
  >
    {{ label }}
  </AppButton>
</template>
